import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router'
import cx from 'helpers/cx'

import Button from 'js/components/Button'
import { CoverImage } from 'js/components/CoverImage'
import { getReadableColor } from 'js/lib/helpers/getContrast'

import { MagazineArticleViewFragment } from '../../../../fragments/MagazineArticleView.fragment.generated'

import styles from './CoverArticle.module.css'

type CoverArticleProps = {
    index: number
    entity: MagazineArticleViewFragment
    issueBackgroundColor?: string
}

const CoverArticle = ({
    index,
    entity,
    issueBackgroundColor,
}: CoverArticleProps) => {
    const { t } = useTranslation()
    const location = useLocation()

    const { title, url, featured } = entity

    const isSmallCard = index > 0

    const buttonBackgroundColor = issueBackgroundColor || '#FFFFFF'

    return (
        <Link
            to={url}
            state={{
                prevPathname: location.state?.prevPathname,
                direction: 'forward',
            }}
            className={cx(
                styles.wrapper,
                isSmallCard ? styles.isSmall : styles.isFeatured,
            )}
            style={
                {
                    '--button-background-color': buttonBackgroundColor,
                    '--button-text-color': getReadableColor(
                        buttonBackgroundColor,
                    ),
                } as React.CSSProperties
            }
        >
            <div className={styles.content}>
                <CoverImage
                    className={styles.coverImage}
                    hideCaption={true}
                    featured={featured as any}
                    size="cover"
                />
                <div className={styles.overlay}>
                    <h2 className={styles.title}>{title}</h2>
                    <Button
                        variant="primary"
                        size={isSmallCard ? 'normal' : 'large'}
                        as="div"
                        className={styles.readButton}
                        aria-hidden
                    >
                        {t('entity-magazine.read-article')}
                    </Button>
                </div>
            </div>
        </Link>
    )
}

export default CoverArticle
